<template>
    <b-modal :id="id" :title="title">
        <b-form-group label="Message" :label-for="`${id}-input-message`">
            <b-form-textarea class="form-control--mid mb-3" v-model="message"></b-form-textarea>
        </b-form-group>

        <template #modal-footer>
            <b-button :disabled="!message || sending" size="lg" variant="primary" @click="sendMessage">
                Send Message
            </b-button>
        </template>
    </b-modal>
</template>
<script>
import Vue from 'vue';
import userService from '@/services/user.service';
import analyst from "@/services/analyst.service";

export default {
    data() {
        return {
            message: '',
            sending: false,
        };
    },
    name: 'MessageModal',
    props: {
        id: String,
        title: String,
        type: {
            type: String,
            default: 'accountManager',
            validator: value => ['accountManager', 'analyst'].indexOf(value) >= 0
        }
    },
    methods: {
        show() {
            this.$bvModal.show(this.id);
        },
        hide() {
            this.$bvModal.hide(this.id);
        },
        async sendMessage() {
            this.sending = true
            let data = false
            let successMessage = ''

            if ('accountManager' == this.type) {
                const response = await userService.messageAccountManager({ message: this.message })
                data = response.data
                successMessage = 'Message sent, your account manager will contact you within 1-2 business days.'
            } else if ('analyst' == this.type) {
                const response = await analyst.messageAnalyst({ message: this.message })
                data = response.data
                successMessage = 'Message Sent'
            }

            if (data === true) {
                Vue.notify({
                    group: 'app',
                    type: 'success',
                    duration: 5000,
                    text: successMessage
                });
                this.message = ''
                this.hide()
            } else {
                Vue.notify({
                    group: 'app',
                    type: 'error',
                    duration: 5000,
                    text: 'Error. Message has not been sent.'
                });
            }

            this.sending = false
        }
    }
}
</script>
